var ObservableQueryRef = (function () {
    function ObservableQueryRef(ref) {
        if (ref) {
            this.setRef(ref);
        }
    }
    ObservableQueryRef.prototype.setRef = function (ref) {
        this.ref = ref;
    };
    ObservableQueryRef.prototype.getRef = function () {
        return this.ref;
    };
    return ObservableQueryRef;
}());
export { ObservableQueryRef };
//# sourceMappingURL=ObservableQueryRef.js.map


//////////////////
// WEBPACK FOOTER
// ./~/apollo-client-rxjs/utils/ObservableQueryRef.js
// module id = 242
// module chunks = 9